import Sidebar from 'MentalHealth/components/Sidebar/Sidebar'
import TopBar from 'MentalHealth/components/TopBar'
import Navbar from 'components/Navbar/Navbar'
import useScopes from 'hooks/useScopes'
import React from 'react'
import { useLocation } from 'react-router-dom'

const AdminLayout = ({ role, children }) => {
  const location = useLocation()
  const { isAdmin } = useScopes()

  const isHomeOrPrescriptionTracking =
    location.pathname === '/dashboard' ||
    location.pathname === '/templates' ||
    location.pathname === "/referral-specialities" ||
    location.pathname === '/prescription-tracking' ||
    location.pathname === '/lab-tracking' ||
    location.pathname === '/medical-note' ||
    location.pathname === '/lab-support' ||
    location.pathname === '/patient' ||
    location.pathname === '/patient/:id' ||
    location.pathname.includes("physio") ||
    location.pathname.includes("logs") ||
    location.pathname.includes("medical-tab") ||
    location.pathname.includes("medical-notes-tab")

  return (
    <div className="container-fluid p-0" style={{ minHeight: '100vh' }}>
      {isAdmin && !isHomeOrPrescriptionTracking && <Sidebar {...{ role }} />}

      <div
        className="content flex-grow-1 p-2"
        style={
          isAdmin && !isHomeOrPrescriptionTracking
            ? { overflowY: 'auto', marginLeft: '80px' }
            : {}
        }
      >
        {isHomeOrPrescriptionTracking ? <Navbar /> : <TopBar />}
        {children}
      </div>
    </div>
  )
}

export default AdminLayout
